import { useQuery } from "@tanstack/react-query";
import { useLocation } from "wouter";
import { Card } from "@/components/ui/card";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";

interface Video {
  id: number;
  videoId: string;
  title: string;
  thumbnail: string;
  categoryId: number;
  sortOrder: number;
}

interface VideoRowProps {
  title: string;
  categoryId: number;
}

export default function VideoRow({ title, categoryId }: VideoRowProps) {
  const [, setLocation] = useLocation();

  const { data: videos, isError, error } = useQuery<Video[]>({
    queryKey: [`/api/categories/${categoryId}/videos`],
  });

  console.log(`Fetching videos for category ${categoryId}:`, { videos, isError, error });

  if (isError) {
    console.error('Error fetching videos:', error);
    return null;
  }

  if (!videos?.length) {
    return null;
  }

  return (
    <div className="px-4 sm:px-6">
      <h2 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-4 text-white">{title}</h2>
      <ScrollArea className="pb-2">
        <div className="flex space-x-3 sm:space-x-4 pb-1">
          {videos.map((video) => (
            <Card
              key={video.id}
              className="flex-shrink-0 w-[140px] sm:w-[180px] md:w-64 bg-zinc-900 hover:bg-zinc-800 active:scale-95 hover:scale-105 transition-all duration-200 cursor-pointer"
              onClick={() => setLocation(`/watch/${video.id}`)}
            >
              <img
                src={video.thumbnail}
                alt={video.title}
                className="w-full aspect-video object-cover rounded-t-lg"
                loading="lazy"
              />
              <div className="p-2 sm:p-4">
                <h3 className="text-xs sm:text-sm font-medium line-clamp-2">{video.title}</h3>
              </div>
            </Card>
          ))}
        </div>
        <ScrollBar orientation="horizontal" className="touch-active:opacity-100" />
      </ScrollArea>
    </div>
  );
}